import React, { useState } from 'react';

import ModalContentWrapper from "./Modals/ModalContentWrapper";

import { setPrivacyRead } from "root/DataFunctions/LoginFns";
import { useGlobalContext } from "root/Contexts/GlobalContext";
import { ConfigOptions } from "root/Contexts/GlobalProvider";

const ModalPrivacyStatement = ( props ) =>
{
    const [ closeAllowed, setCloseAllowed ] = useState ( false ) ;
    const [ buttonState, setButtonState ] = useState ( 'disabled' ) ;

    const doSetPrivacyRead = () =>
    {
        setPrivacyRead((response) => {
            props.onClose() ;
        }) ;
    }

    const onClickCancel = () =>
    {
        if ( closeAllowed === true )
        {
            doSetPrivacyRead() ;
        }
    }

    const onScrollBottomReached = () =>
    {
        console.log ("Bottom Reached") ;

        setCloseAllowed(true);
        setButtonState('') ;
    }

    const onFocus = ( e ) =>
    {
        e.preventDefault();
        e.target.focus({preventScroll: true});
    }

    const { getCustomObject } = useGlobalContext() ;

    const privacyTitle = getCustomObject( ConfigOptions.PRIVACY_HEADER_TITLE ) ;
    const privacySubtitle = getCustomObject( ConfigOptions.PRIVACY_SUB_TITLE ) ;

    return (
        <ModalContentWrapper onScrollBottomReached={onScrollBottomReached} >
            <div className='privacy-scroller'>
                <h1 style={{textAlign: 'center'}}>{ privacyTitle }</h1>
                <h2 style={{textAlign: 'center'}}>{ privacySubtitle}</h2>
                <h2 style={{textAlign: 'center'}}>Please read the notice below which defines expected usage guidelines and behaviour expected from system users.</h2>

                <ul>
                    <li>All users must take responsibility for their own use of new technologies, making sure that they use technology safely, responsibly and legally.</li>
                    <li>All users must be active participants in e-safety education, taking personal responsibility for their awareness of the opportunities and risks posed by new technologies.</li>
                    <li>No applications or services accessed by users may be used to bring the provider, or its members, into disrepute.</li>
                    <li>All users have a responsibility to report any known misuses of technology, including the unacceptable behaviours of others</li>
                    <li>All users have a duty to respect the technical safeguards, which are in place. Any attempt to breach technical safeguards, conceal network identities, or gain unauthorised access to systems and services, is unacceptable.</li>
                    <li>All users have a duty to report failings in technical safeguards, which may become apparent when using the systems and services.</li>
                    <li>All users have a duty to protect their passwords and personal network logins, and should log off the network when leaving workstations unattended. Any attempts to access, corrupt or destroy other users’ data, or compromise the privacy of others in any way, using any technology, is unacceptable.</li>
                    <li>All users should understand that system activity may be logged for audit purposes.</li>
                    <li>All users should be aware that in certain circumstances where unacceptable use is suspected, enhanced monitoring and procedures may come into action.</li>
                    <li>All users must take responsibility for reading and upholding the standards laid out in the Acceptable Use Policy.</li>
                </ul>
            </div>

            <div className="row" style={{textAlign: 'center'}}>
                <button  disabled={buttonState} onClick={onClickCancel} style={{ marginLeft: '15px'}} className="btn btn-icon btn-green btn-icon-right btn-small">I've Read It!<i className="et-check"/></button>
            </div>

        </ModalContentWrapper>
    )
}

export default ModalPrivacyStatement ;